import React from "react";
import { GenericTableColumn } from "@ui-components/Table/GenericTable";
import { ActionsIcons } from "./ActionIcons";
import GenericRowActionsMenu from "@ui-components/Menu/GenericRowActionsMenu";
import { GenericTag } from "@ui-components/Tag/GenericTag";
import GenericInput from "@ui-components/Input/GenericInput";
import { ReactComponent as IconCancel } from "@assets/Icons/IconCrossSquare.svg";
import { ReactComponent as IconCheck } from "@assets/Icons/IconCheckSquared.svg";


export interface Auth0Customer {
  user_id: string;
  name: string;
  customerId: string;
  nameDisplay: string;
  domain: string;
  hasMFA: boolean;
  products: Array < {
    id: number;
    name: string;
  }>
}

export const getAuth0CustomersColumns = (
  handleEdit: (userId: string, currentName: string) => void,
  handleDelete: (userId: string) => void,
  editCustomerId: string | null | undefined,
  editedName: string,
  setEditedName: (name: string) => void,
  handleSaveEdit: (userId: string) => void,
  handleCancelEdit: () => void,
  /** On a phone, edit and delete sit behind "⋯" on the card (CTX-1378). */
  isPhone = false
): GenericTableColumn<Auth0Customer>[] => [
// export const auth0CustomersColumns: GenericTableColumn<Auth0Customer>[] = [
  {
    header: "Name",
    renderCell: (row) => 
      row.user_id === editCustomerId ? (
        <GenericInput 
          type="text"
          value={editedName}
          onChange={(val: string) => setEditedName(val)}
          placeholder="Enter name"
          fullWidth    
        />
      ) : (
        <div className="flex flex-col">
          <span></span>
          {row.name}
          <span className="text-xs text-gray-500">
            ID: {row.customerId}
          </span>
        </div>
      )
  },
  {
    header: "Display Name",
    renderCell: (row) => row.nameDisplay ? row.nameDisplay : "Not assigned",
  },
  {
    header: "MFA",
    renderCell: (row) => (
      <GenericTag
        label={row.hasMFA ? "Configured" : "Not Configured"}
        variant={row.hasMFA ? "success" : "default"}
        size="small"
      />
    ),
  },
  {
    header: "Products",
    renderCell: (row) => row.products ? row.products?.map((r) => r.name).join(", ") : 'Not Assigned',
  },
  {
    header: "Actions",
    renderCell: (row) => 
      row.user_id === editCustomerId ?(
        <div className="flex gap-2">
          <IconCheck
            onClick={() => handleSaveEdit(row.user_id)}
            className="
            border border-semantic-border-secondary
            rounded text-semantic-text-secondary
            cursor-pointer
            w-5 h-5"
          />
          <IconCancel
            onClick={handleCancelEdit}
            className="
            border border-semantic-border-secondary
            rounded text-semantic-text-secondary
            cursor-pointer
            w-5 h-5"
          />
        </div>
      ) : isPhone ? (
        <GenericRowActionsMenu
          ariaLabel={`Actions for ${row.name}`}
          actions={[
            { id: "edit", label: "Edit name", onSelect: () => handleEdit(row.user_id, row.name) },
            { id: "delete", label: "Delete", onSelect: () => handleDelete(row.user_id) },
          ]}
        />
      ) : (
      <ActionsIcons
        row={row}
        onEdit={(userId) => handleEdit(userId, row.name)}
        onDelete={handleDelete}
      />
      )
  },
];
